import React__default from 'react';
import { SelectCore } from '../shared/components/Select.mjs';
import { Label } from './Label.mjs';
import { MenuItem } from './MenuItem.mjs';
import { Typography } from './Typography.mjs';

const LabelSecondary = (props)=>{
    return /*#__PURE__*/ React__default.createElement(Label, {
        labelColor: "secondary",
        ...props
    });
};
const checkIconSx = {
    color: (theme)=>theme.styleConfig.colors.primary
};
const selectSx = {
    color: (theme)=>theme.styleConfig.colors.primary
};
const Select = (props)=>{
    return /*#__PURE__*/ React__default.createElement(SelectCore, {
        ...props,
        LabelComponent: props.labelColor === 'secondary' ? LabelSecondary : Label,
        MenuItemComponent: MenuItem,
        TypographyComponent: Typography,
        checkIconSx: checkIconSx,
        selectSx: selectSx
    });
};

export { Select };
//# sourceMappingURL=Select.mjs.map
